"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/SynchronizedWarning` instead */
export const SynchronizedWarning = createSVGIcon(
  <>
    <path
      d="m18.857 15.428 3.429-.857.857 3.429"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.286 14.571A11.31 11.31 0 0 1 12 22.286a10.32 10.32 0 0 1-9.663-6.772M5.143 8.571l-3.428.858L.857 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.714 9.429A11.63 11.63 0 0 1 12 1.714a10.32 10.32 0 0 1 9.664 6.772M12 6v6.857"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.143 17.143a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SynchronizedWarning",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
